
import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { AssetsModule } from '@/store/modules/asset'
import { AssetFile, SingleAssetUsage } from '@/store/modules/asset'
import { ImageClipper } from '@/utils/imageClipper'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'

@Component({
    name: 'image-editor-error'
})
export default class ImageEditorError extends Vue {

    @Prop() private step!: number
    @Prop() private usageName!: string

    private imageClipper = ImageClipper.getImageClipper(false, this.step, this.usageName)

    get error() {
        return ToolbarModule.error
    }
}
